import { MascotBubble } from '@tankef/ui';

import type { StepType } from '@reactour/tour';

export const INV_TABLE_TOUR_ID = 'inv-table';

export const invTableSteps: StepType[] = [
  {
    selector: '[data-tour="investments-table"]',
    position: 'top',
    content: (
      <MascotBubble emotion="thinking" size="sm" direction="right" showPointer={false}>
        Toca una inversión activa para ver la <strong>tabla de amortización</strong>, retención ISR
        y descargar tu estado de cuenta.
      </MascotBubble>
    ),
  },
];
